/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from '@material-ui/core';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import PropTypes from 'prop-types';

// import icons
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(
  (theme) => ({
    root: {},
    dialogFade: {
      '&-appear': {
        '&-enter': {
          opacity: 0,
        },
      },
      '&-appear-active': {
        '&-enter-active': {
          opacity: 1,
          transition: 'opacity 500ms linear',
        },
      },

      '&-fade-exit': {
        opacity: 1,
      },
      '&-exit-active': {
        opacity: 0,
        transition: 'opacity 500ms linear',
      },
    },
    dialogOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      width: '100vw',
      overflow: 'auto',
      zIndex: '999',
      background: 'rgba(177, 184, 197, 0.7)',
    },
    dialogContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      display: 'flex',
      height: '100vh',
    },
    dialog: {
      width: '660px',
      maxWidth: '100%',
      position: 'relative',
      padding: '24px 24px 56px 24px',
      boxShadow: '0 2px 10px 1px rgba(0, 0, 0, 0.12)',
      backgroundColor: theme.palette.$lightWhite,
      borderRadius: '8px',
      textAlign: 'left',
      [theme.breakpoints.down('sm')]: {
        maxWidth: '85%',
        padding: '20px',
      },
    },
    closeBtn: {
      position: 'absolute',
      padding: '10px',
      top: '14px',
      right: '14px',
      lineHeight: '12px', // remove empty space on top and bellow icon
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      fontSize: theme.typography.$fzH1,
      color: theme.palette.$dark50,
      '&:focus': {
        outline: 'none',
      },
    },
    iconStyle: {
      fontSize: '24px',
      color: theme.palette.$dark50,
    },
  }),
  'dialog-component',
);

const fadeAnimation = {
  appear: 200,
  enter: 200,
  exit: 200,
};

const Dialog = ({
  isOpen,
  width,
  hasCloseBtn = true,
  onRequestClose,
  children,
}) => {
  const handleClose = (event) => {
    event.stopPropagation();
  };
  const classes = useStyles();
  return (
    <TransitionGroup component={null} appear exit>
      {isOpen && (
        <CSSTransition
          key="overlay"
          timeout={fadeAnimation}
          classNames={classes.dialogFade}
          // onClick={onRequestClose}
          id="common-dialog"
        >
          <div className={classes.dialogOverlay}>
            <div className={classes.dialogContainer}>
              <div
                onClick={(event) => handleClose(event)}
                className={classes.dialog}
                style={{ width }}
                aria-hidden="true"
              >
                {hasCloseBtn && (
                  <button
                    type="button"
                    className={classes.closeBtn}
                    onClick={onRequestClose}
                  >
                    <CloseIcon className={classes.iconStyle} />
                  </button>
                )}
                <div className="dialog-content">{children}</div>
              </div>
            </div>
          </div>
        </CSSTransition>
      )}
    </TransitionGroup>
  );
};

Dialog.defaultProps = {
  isOpen: false,
  hasCloseBtn: true,
  onRequestClose: _ => _,
};

Dialog.propTypes = {
  isOpen: PropTypes.bool,
  hasCloseBtn: PropTypes.bool,
  onRequestClose: PropTypes.func,
};
export default Dialog;
